import React, { Component } from 'react';
import Link from 'gatsby-link';
import NumberFormat from 'react-number-format';

class fePage extends Component {
    constructor(props) {
        super(props);

 
    }

    render() {
        return (
            <div>
                <div className="midd_section_inner">
                    <div className="midd_heading_section">
                        <h1 className="fe_top_heading">Optimization Investment Assumptions</h1>
                        <p className="fe_paragraph">How much will you spend on Optimization Tools and People?</p>
                    </div>
                    <div className="midd_form fe_box_shadow step_3">
                        <label className="fe_label">Annual Investment ($)</label>
                        <NumberFormat thousandSeparator={true} allowNegative={false}  className="fe_input" data-rel="enAnnualInvestment" placeholder="Enter Annual Investment Value..." onValueChange={this.props.updateValue} value={this.props.data.enAnnualInvestment} />
                    </div>
                </div>

                <div className="fe_btn_formatting style_2 step_3">
                    <div className="btn back_btn" >
                        <Link to="revenue-ltv"  > back </Link>
                    </div>
                    <div className="btn next_btn" data-enable={this.props.data.result} >
                        <Link to="result"  > CALCULATE </Link>
                    </div>
                </div>
            </div>

        );
    }
}

export default fePage;


// WEBPACK FOOTER //
// ./src/pages/investment.js